'use strict';

function CompanyPublicationService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId', {companyId: '@companyId', publicationId: '@id'}, {
    'update': {
      method: 'PUT'
    },
    'updateMassEdit': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/publications/mass-edit'
    },
    'updateCertifyDoc': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/verify'
    },
    'queryDrafts': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/publications/drafts',
      isArray: true
    },
    'lockFileUpload': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/upload-lock'
    },
    'unlockFileUpload': {
      method: 'DELETE',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/upload-lock'
    },
    "queryWatched": {
      method: "GET",
      isArray: true,
      url: config.apiBase + '/companies/:companyId/users/:userId/watched-publications'
    },
    "deleteArchives": {
      method: "DELETE",
      url: config.apiBase + '/companies/:companyId/publications/archives'
    },
    'createFlowVerify': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/flow-verifies'
    },
    'updateFlowVerify': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/flow-verifies/:publicationsVerifyId'
    },
    'queryFlowVerifies': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/publications/flow-verifies',
      isArray: true
    },
    'getFlowVerify': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/flow-verifies/:publicationsVerifyId',
    },
    "getPostLastest": {
      method: "GET",
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/posts/lastest',
      isArray: true
    },
    'copyObject':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/copy',
      method: 'POST'
    },
    'createCard': {
      url:  config.apiBase + '/companies/:companyId/publications/:publicationId/convert',
      method: 'POST',
      params: {"target" : "@target"},
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationService', ['$resource', 'config', CompanyPublicationService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationService.js
// module id = 5
// module chunks = 0